module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-login-extra"
  }, [_c('van-cell-group', {
    staticClass: "score-cell"
  }, [(_vm.startId <= 0) ? _c('div', {
    staticClass: "dexame-warn"
  }, [_vm._v("\n        链接无效：缺少场次参数 start_id，请使用现场提供的二维码进入。\n      ")]) : (_vm.sessionHint) ? _c('div', {
    staticClass: "dexame-session"
  }, [_c('div', {
    staticClass: "dexame-session-title"
  }, [_vm._v(_vm._s(_vm.sessionHint))]), _vm._v(" "), _c('div', {
    staticClass: "dexame-session-sub"
  }, [_vm._v("输入身份证号完成本场次裁判绑定")])]) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "身份证号",
      "left-icon": require('../../../assets/images/score/login-card.png'),
      "clearable": "",
      "readonly": _vm.readonly,
      "disabled": _vm.startId <= 0,
      "placeholder": "请输入身份证号"
    },
    on: {
      "focus": _vm.onFocus
    },
    model: {
      value: (_vm.formData.id_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_code", $$v)
      },
      expression: "formData.id_code"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "score-button"
  }, [(!_vm.saveLoading) ? _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "color": "linear-gradient(to right, #72CAF9, #2492FB)",
      "disabled": _vm.startId <= 0
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          接收邀请\n        ")]) : _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "color": "linear-gradient(to right, #65F6D6, #0EB993)"
    }
  }, [_vm._v("\n          提交中...\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dexame-footer-hint"
  })], 1)], 1), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.keyShow,
      "extra-key": "X",
      "close-button-text": "完成"
    },
    on: {
      "close": function($event) {
        _vm.keyShow = false
      }
    },
    model: {
      value: (_vm.formData.id_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_code", $$v)
      },
      expression: "formData.id_code"
    }
  }), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "绑定成功",
      "confirm-button-text": "去打分"
    },
    on: {
      "confirm": _vm.onBindSuccessGo
    },
    model: {
      value: (_vm.successShow),
      callback: function($$v) {
        _vm.successShow = $$v
      },
      expression: "successShow"
    }
  }, [(_vm.bindResult) ? _c('div', {
    staticClass: "dexame-success-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.bindResult.saiqu_name) + " " + _vm._s(_vm.bindResult.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.bindResult.name) + "（" + _vm._s(_vm.bindResult.caipan_type) + "）")]), _vm._v(" "), (_vm.bindResult.already) ? _c('p', {
    staticClass: "dexame-muted"
  }, [_vm._v("您已绑定过本场次")]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-login-box"
  }, [_c('div', {
    staticClass: "score-login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0ca910c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/dexame/DexameLogin.vue
// module id = 2572
// module chunks = 0